"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RelativeDateTooltip = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _Tooltip = _interopRequireDefault(require("../Tooltip"));

var _DateHelper = require("./DateHelper");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var RelativeDateTooltip = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(RelativeDateTooltip, _React$Component);

  var _super = _createSuper(RelativeDateTooltip);

  function RelativeDateTooltip(props) {
    var _this;

    (0, _classCallCheck2.default)(this, RelativeDateTooltip);
    _this = _super.call(this, props);
    _this.state = {};
    return _this;
  }

  (0, _createClass2.default)(RelativeDateTooltip, [{
    key: "render",
    value: function render() {
      var date = this.props.date || Date.now();
      var title = (0, _DateHelper.toDateTimeZone)(date, this.props.timeZone, false);
      return /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
        id: "".concat(this.props.id, "-").concat(date),
        delay: "instant",
        title: title,
        placement: "bottom-end"
      }, /*#__PURE__*/_react.default.createElement("span", {
        style: {
          marginLeft: ".5rem",
          marginTop: "0.22rem"
        }
      }, (0, _DateHelper.getFormattedDateStringRelative)(date, Date.now())));
    }
  }]);
  return RelativeDateTooltip;
}(_react.default.Component);

exports.RelativeDateTooltip = RelativeDateTooltip;